<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        (click)="modalCtrl.dismiss()"
        fill="clear"
      >
        <ion-icon
          size="large"
          name="close"
          aria-label="close"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="mable-section ion-margin-top">
    <img
      class="width-100 ion-padding-horizontal"
      src="assets/img/mable/paper-plane.svg"
      alt="paper plane"
    />

    <mable-heading heading="h2">Contact us to proceed further</mable-heading>

    <div class="sub-section ion-margin-horizontal">
      <app-email-call-contact
        heading="Contact us to find out more."
        headingType="h3"
      ></app-email-call-contact>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <mable-button
      category="orange-500"
      (onClick)="redirect()"
      expand="block"
      >Ok, got it</mable-button
    >
  </ion-toolbar>
</ion-footer>
